export default __webpack_public_path__ + "static/media/To Claim Their Bones.83ecc221.png";